import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AddSlabDetail,
  DeleteSlabDetail,
  fetchSlabDetailList,
  fetchSlabList,
  UpdateSlabDetail,
} from "../../Redux/WhatsappSlice/Slab";
import { toast } from "react-toastify";
import WpDynamicTable from "../../Components/WhatsappTable/WpDynamicTable";
import Loader from "../../Components/Loader/Loader";

const Add_Slab_Detail = () => {
  const getFormattedDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, "0");
    const day = now.getDate().toString().padStart(2, "0");
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}`; // ✅ No seconds
  };

  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear(); // Get the full 4-digit year
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };

  const dispatch = useDispatch();

  const { SlabDataList, SlabDetailList } = useSelector((state) => state.Slab);

  const [formData, setFormData] = useState({
    whaSlabName: "",
    FromMSGToMSG: "",
    Price: "",
  });

  const [editId, setEditId] = useState(null);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    dispatch(fetchSlabList());
    dispatch(fetchSlabDetailList());
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.whaSlabName) newErrors.whaSlabName = "Slab Name is required.";
    if (!formData.FromMSGToMSG) newErrors.FromMSGToMSG = "Range is required.";
    if (!formData.Price) {
      newErrors.Price = "Price is required.";
    } else if (isNaN(formData.Price) || Number(formData.Price) <= 0) {
      newErrors.Price = "Price must be a positive number.";
    }
    return newErrors;
  };

  const handleDelete = async (row) => {
    const isConfirmed = window.confirm(
      `Are you sure you want to delete this Slab?`
    );
    if (!isConfirmed) return;

    try {
      await dispatch(DeleteSlabDetail({ id: row.MainId })).unwrap();
      toast.success("Slab Detail deleted successfully!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
      dispatch(fetchSlabDetailList()); // refresh list
    } catch (error) {
      toast.error(`Failed to delete Slab Detail: ${error}`, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
    }
  };

  const handleEdit = (row) => {
    setEditId(row.MainId);
    setFormData({
      whaSlabName: row.WhaSlabName,
      FromMSGToMSG: row.FromMSGToMSG,
      Price: row.Price,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) {
      toast.error("Please fix validation errors.");
      return;
    }

    const selectedSlab = SlabDataList.find(
      (slab) => slab.WhaSlabName === formData.whaSlabName
    );
    if (!selectedSlab || !selectedSlab._id) {
      toast.error("Invalid Slab Name selected.");
      return;
    }

    const whaSlabID = selectedSlab._id;
    const dataToPost = {
      FromMSGToMSG: formData.FromMSGToMSG,
      Price: formData.Price,
      ModifyDate: getFormattedDateTime(),
    };

    try {
      if (editId) {
        await dispatch(UpdateSlabDetail({ id: editId, dataToPost })).unwrap();
        toast.success("Slab detail updated successfully!");
      } else {
        await dispatch(AddSlabDetail({ whaSlabID, dataToPost })).unwrap();
        toast.success("Slab detail added successfully!");
      }

      setFormData({ whaSlabName: "", FromMSGToMSG: "", Price: "" });
      setEditId(null);
      dispatch(fetchSlabDetailList());
    } catch (error) {
      toast.error(`Failed to submit: ${error.message || "Unknown error"}`);
    }
  };

  const columns = [
    { field: "id", headerName: "No", flex: 1 },
    { field: "WhaSlabName", headerName: "Slab Name", flex: 1 },
    { field: "FromMSGToMSG", headerName: "Range", flex: 1 },
    { field: "Price", headerName: "Price", flex: 1 },
    { field: "ModifyDate", headerName: "Modify Date", flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <div className="flex space-x-2 justify-center">
          <button
            className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
            onClick={() => handleEdit(params.row)}
          >
            Update
          </button>
          <button
            className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
            onClick={() => handleDelete(params.row)}
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  const filteredRows = (SlabDetailList || [])?.map((el, index) => ({
    id: index + 1,
    MainId: el._id,
    WhaSlabName: el?.WhaSlabID?.WhaSlabName,
    FromMSGToMSG: el?.FromMSGToMSG,
    Price: el?.Price,
    ModifyDate: formatDisplayDate(el?.ModifyDate),
  }));

  if (
    !SlabDataList ||
    !SlabDetailList
  ) {
    return <Loader />;
  }

  return (
    <>
      <div className="">
        <div className="title">
          <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
            {editId ? "Update Slab Detail" : "Add Slab Detail"}
          </h3>
        </div>

        <div className="Form_bg_color bg-white shadow-sm rounded-xl mt-4">
          <form
            onSubmit={handleSubmit}
            className="grid grid-cols-12 gap-4 p-3 rounded-2xl"
          >
            {/* Slab Name Dropdown */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Slab Name</h5>
              {editId ? (
                <>
                  <input
                    type="text"
                    name="whaSlabName"
                    value={formData.whaSlabName}
                    readOnly
                    className="bg-gray-200 text-gray-700 w-full p-[10px] border-2 border-black rounded cursor-not-allowed"
                  />
                </>
              ) : (
                <>
                  <select
                    name="whaSlabName"
                    value={formData.whaSlabName}
                    onChange={handleChange}
                    className="bg-[#F3F8FB] w-full p-[10px] border-2 border-black rounded"
                  >
                    <option value="">Select Slab Name</option>
                    {[...(SlabDataList || [])]
                      .sort((a, b) => (a.WhaSlabName || "").localeCompare(b.WhaSlabName || ""))
                      .map((option) => (
                        <option key={option.id} value={option.WhaSlabName}>
                          {option.WhaSlabName}
                        </option>
                      ))}
                  </select>
                </>
              )}
              {errors.whaSlabName && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.whaSlabName}
                </p>
              )}
            </div>

            {/* Range Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Range</h5>
              <input
                type="text"
                name="FromMSGToMSG"
                placeholder="Enter Your Range"
                value={formData.FromMSGToMSG}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.FromMSGToMSG && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.FromMSGToMSG}
                </p>
              )}
            </div>

            {/* Price Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="my-2 font-semibold">Price</h5>
              <input
                type="number"
                name="Price"
                placeholder="Enter Price"
                value={formData.Price}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.Price && (
                <p className="text-red-500 text-sm mt-1">{errors.Price}</p>
              )}
            </div>

            {/* Submit Button */}
            <div className="submit_Form col-span-12 flex justify-center">
              <button type="submit" className="All_button">
                {editId ? "Update" : "Submit"}
              </button>

              {editId && (
                <button
                  type="button"
                  className="bg-gray-500 text-white ms-2 px-4 py-2 rounded hover:bg-gray-600"
                  onClick={() => {
                    setFormData({
                      whaSlabName: "",
                      FromMSGToMSG: "",
                      Price: "",
                    });
                    setEditId(null);
                    setErrors({});
                  }}
                >
                  Cancel
                </button>
              )}
            </div>
          </form>
        </div>

        <div className="px-2 py-6">
          <div className="title">
            <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
              View Slab Detail
            </h3>
          </div>
          <div className="rounded-lg overflow-x-auto mt-5">
            <WpDynamicTable columns={columns} rows={filteredRows} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Add_Slab_Detail;
